export default __webpack_public_path__ + "static/media/flag-congo(democratic).cc9a34ee.svg";